/* @flow */
import React, { Component } from 'react'
import Chart from './Chart'
import type { Data, ActiveFilters, Lang, Mode, Initial } from './App'
import type { DateRange } from './Chart'

export type Display = {
  chart: boolean,
  buttonGroup: boolean,
  legend: boolean
}

type Props = {
  appId: string,
  data: Data,
  initial: Initial,
  width: number,
  initDateRange: ?DateRange,
  display: Display,
  urlTemplate: string,
  lang: Lang,
  activeFilters: ActiveFilters,
  mode: Mode
}

class ChartContainer extends Component<Props> {
  setChartSize = () => {
    const { width } = this.props
    const h = Math.round(width * 1 / 4)
    const height = h >= 450 ? h : 450
    const margin = {
      top: 20,
      right: 20,
      bottom: 100,
      left: 35
    }
    const margin2 = {
      top: height - margin.bottom + 40,
      right: 20,
      bottom: 20,
      left: 35
    }
    return { width, height, margin, margin2 }
  }
  render () {
    const { data, initial, initDateRange, display, urlTemplate, activeFilters, lang, appId, mode } = this.props
    return (
      <Chart
        appId={appId}
        data={data}
        initial={initial}
        {...this.setChartSize()}
        initDateRange={initDateRange}
        display={display}
        urlTemplate={urlTemplate}
        activeFilters={activeFilters}
        lang={lang}
        mode={mode}
      />
    )
  }
}

export default ChartContainer






// WEBPACK FOOTER //
// ./src/ChartContainer.js